import * as deepmerge from 'deepmerge'
import dotProp from 'dot-prop-immutable'

import { setConfig } from './config'

export default insights => (clientId, config, history = null, context = window) => {
  const initialConfig = deepmerge.all([
    { clientId, history, context },
    dotProp.get(config, 'common', {}),
    dotProp.get(config, `apps.${clientId}.config`, {})
  ])
  setConfig(initialConfig)
  insights.create()
}
